<template>
  <div class="content">
    <!-- 顶部导航TopNav：左边是公司logo和公司名称(上下两行，上面中文大一点，下面英文小一点) -->
    <TopNav class="top-nav"></TopNav>

    <div class="main-container">
      <!-- 左侧菜单 -->
      <Nav
        class="left_content"
        :isCollapse="isCollapse"
        :navData="filterNavList"
        :active="active"
        @clickNav="clickNav"
        @collapse="collapse"
        :style="{ width: leftWidth }"
      ></Nav>

      <!-- 右侧模块 -->
      <div class="right_content" :style="{ width: rightWidth }">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import TopNav from "@/components/topNav/index.vue";
import Nav from "@/components/navMenu/index.vue";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    TopNav,
    Nav
  },

  async mounted() {
    /* 根据权限初始化导航 迁移到了store*/
    // this.navData = JSON.parse(JSON.stringify(this.navList));
    // this.filterFun(this.navData, this.roleList);
    // this.$store.commit("updataFilterNavList", this.navData);
    /* 初始化导航高亮 */
    // this.findFun(
    //   this.filterNavList,
    //   window.location.hash.substring(1, window.location.hash.length)
    // );
    // if (!this.active) {
    //   this.$router.push({ name: "Errow" });
    //   return;
    // }
  },

  data() {
    return {
      isCollapse: false, //是否折叠导航栏
      leftWidth: "220px",
      rightWidth: "calc(100% - 250px)",
      routerName: "",
      roleList: [] //权限
    };
  },
  computed: {
    ...mapState(["userInfo", "filterNavList", "active"])
  },
  watch: {},
  methods: {
    ...mapMutations(["updataActive"]),
    clickNav(item) {
      // this.active = item.id;
      this.updataActive(item.id);
      this.routerName = item.routerName;
      this.$router.push({ name: item.routerName });
    },
    collapse() {
      this.isCollapse = !this.isCollapse;
      if (this.isCollapse) {
        this.leftWidth = "65px";
        this.rightWidth = "calc(100% - 65px)";
      } else {
        this.leftWidth = "220px";
        this.rightWidth = "calc(100% - 220px)";
      }
    }
    /*  找到导航 id */
    // findFun(navData, path) {
    //   for (let index = 0; index < navData.length; index++) {
    //     if (navData[index]?.path === path) {
    //       this.active = navData[index]?.id;
    //     }
    //     if (
    //       navData[index]?.children &&
    //       navData[index]?.children.length > 0 &&
    //       navData[index]?.path !== path
    //     ) {
    //       this.findFun(navData[index].children, path);
    //     }
    //   }
    // },

    /* 筛选全量导航 */
    // filterFun(navData, roleList) {
    //   for (var index = navData.length - 1; index >= 0; index--) {
    //     if (
    //       navData[index]?.children &&
    //       navData[index]?.children.length > 0 &&
    //       roleList?.indexOf(navData[index].id) >= 0
    //     ) {
    //       this.filterFun(navData[index].children);
    //     }
    //     if (roleList?.indexOf(navData[index].id) < 0) {
    //       navData.splice(index, 1);
    //     }
    //   }
    // },
  }
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  min-width: 800px;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .top-nav {
    width: 100%;
    flex-shrink: 0;
  }

  .main-container {
    display: flex;
    flex: 1;
    overflow: hidden;

    .left_content {
      flex-shrink: 0;
      overflow-y: auto;
      transition: width 0.3s;
    }

    .right_content {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      padding: 10px;
    }
  }
}
</style>
